/*
 *
 * Producer -- Rowe
 * Time -- 2018/2/7
 * Function -- 业务 数据三列最优排序
 *
 */

export function dateSortUtil(model){
    var f = model;
    var a = [];
    f.results.subCategoryList.map((d, i) => {
        if (d.content === ""){
            return
        }
        a.push({
            c: d.content,
            r: d.childCategoryList
        })
    });
    var c = Math.ceil(a.reduce((prev, cur) => {
        return ((prev && prev.r) ? prev.r.length || 0 : prev) + ((cur && cur.r) ? cur.r.length : 0) }) / 3);

    var abs, f, s, t, fst, no;
    fst = [];

    for (var m = 1; m <= a.length; m++) {
        no = a.length - m;
        for (var n = 1; n <= no; n++) {
            if (m == 0 || n == 0 || no - n == 0){
                break
            }
            f = 0, s = 0, t = 0;
            for (var i in a.slice(0, m)) {
                f += a.slice(0, m)[i].r.length;
            }
            for (var i in a.slice(m, n + m)) {
                s += a.slice(m, n + m)[i].r.length;
            }
            for (var i in a.slice(m + n, m + no)) {
                t += a.slice(m + n, m + no)[i].r.length;
            }
            /* console.log(a.slice(0, m))
            console.log(a.slice(m, n + m))
            console.log(a.slice(m + n, m + no)) */
            Math.abs(c - f) + Math.abs(c - s) + Math.abs(c - t)
            fst.push({
                "abs": Math.abs(c - f) + Math.abs(c - s) + Math.abs(c - t),
                res: [a.slice(0, m), a.slice(m, n + m), a.slice(m + n, m + no)]
            })
        }
    }

    var t = fst.sort((a, b) => a.abs - b.abs)[0];
    var rule = [];
    rule[0] = t.res[0].length;
    rule[1] = t.res[1].length;
    rule[2] = t.res[2].length;
    return rule;
}


// WEBPACK FOOTER //
// ./common/Utils/dateSortUtils.js